// import types
import type { ChangeEvent } from 'react';

export type RosterCycleEndResult = {
  nextOccurrence: string;
  cycleDate: string;
  rounds: RosterCycleRound[];
};

type RosterCycleRound = {
  start: string;
  end: string;
  autoConnect: boolean;
};

export type PlanningCycleRound = {
  startIndex: number;
  endIndex: number;
  autoConnect: boolean;
};

export type POSTBody = {
  cycleWindow: number;
  enabled: boolean;
  recurrenceRule?: RecurrenceRuleType;
  rosterState: 'PUBLISHED' | 'VISIBLE';
  rounds?: PlanningCycleRound[];
};

export enum PeriodTypeEnum {
  WEEK = 'WEEK',
  MONTH = 'MONTH'
}

export type RecurrenceRuleType = {
  start: string;
  interval: number;
  periodType?: PeriodTypeEnum.WEEK | PeriodTypeEnum.MONTH;
  dayOfMonth?: number;
  setPosition?: number;
  dayInWeekSet?: string[];
  recurrenceRange?: {
    type: 'NO_END' | 'END_BY' | 'END_AFTER';
    end?: Date;
    numberOfOccurrences?: number;
  };
};

export type PlanningCycle = {
  cycleWindow: number;
  dayOfMonth?: number;
  interval: number;
  periodType?: PeriodTypeEnum.WEEK | PeriodTypeEnum.MONTH;
  rounds: PlanningCycleRound[];
  setPosition: number;
  start: string;
  dayInWeekSet?: string[];
  recurrenceRule?: RecurrenceRuleType | null;
  rosterState?: 'PUBLISHED' | 'VISIBLE';
  enabled?: boolean;
};

export type RecurrenceRuleProps = {
  onRecurrenceRuleChange: (recurrenceRule: RecurrenceRuleType | null) => void;
  recurrenceRule?: RecurrenceRuleType | null;
};

export type PlanningCycleDialogProps = {
  open: boolean;
  onHidden: (wasSaved: boolean) => void;
  type: 'PUBLISHED' | 'VISIBLE';
  currentPlanningCycle?: PlanningCycle | null;
  costCenterId: number;
};

export type PlanningCycleInfoProps = {
  planningCycle?: PlanningCycle;
  onEditClick: () => void;
  isChecked: boolean;
  onCheckboxChange?: (e: ChangeEvent<HTMLInputElement>) => void;
};

export type RosterStateSettingsValues = {
  costCenterId: number;
  planningCyclePayload: {
    rosterState: 'PUBLISHED' | 'VISIBLE';
    enabled: boolean;
    recurrenceRule?: RecurrenceRuleType | null;
    cycleWindow?: number | null;
    rounds?: PlanningCycleRound[];
  };
};

export type PlanningCycleDialogContentProps = {
  type: 'PUBLISHED' | 'VISIBLE';
  setRecurrenceRule: (recurrenceRule: RecurrenceRuleType | null) => void;
  recurrenceRule: RecurrenceRuleType | null;
  cycleWindow: number;
  setCycleWindow: (cycle: number) => void;
  rounds: PlanningCycleRound[];
  updateRound: (roundIndex: number, round: PlanningCycleRound) => void;
  deleteRound: (roundIndex: number) => void;
  addRound: () => void;
  rosterCycles: RosterCycleEndResult[] | null;
};
